export default function HeritageMark({
  size = 36,
  bg = "#284A3B",
  stroke = "#FDFBF7",
  accent = "#C86A51",
  className = "",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      className={className}
      aria-label="Heritage"
    >
      <rect width="64" height="64" rx="14" fill={bg} />
      <path
        d="M22 18 V46"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M42 18 V46"
        stroke={stroke}
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M22 32 Q32 24 42 32"
        stroke={accent}
        strokeWidth="4"
        strokeLinecap="round"
        fill="none"
      />
      <circle cx="32" cy="30" r="1.9" fill={accent} />
    </svg>
  );
}
